import { render, staticRenderFns } from "./DDPThirdPartCode.vue?vue&type=template&id=346047d2&scoped=true&"
import script from "./DDPThirdPartCode.vue?vue&type=script&lang=ts&"
export * from "./DDPThirdPartCode.vue?vue&type=script&lang=ts&"
import style0 from "./DDPThirdPartCode.vue?vue&type=style&index=0&id=346047d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346047d2",
  null
  
)

export default component.exports